import { render, staticRenderFns } from "./VentanaOperacionesCambioPostulacion.vue?vue&type=template&id=46c84763"
import script from "./VentanaOperacionesCambioPostulacion.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesCambioPostulacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports